import LegalPageShell from "../components/legal/LegalPageShell";
import { PlanFrequencyTable, PlanLimitTable } from "../components/legal/PlanTable";
import { PLAN_UNLIMITED_NOTE } from "../lib/planCatalog";

export default function CommercialTransactionsPage() {
  return (
    <LegalPageShell>
          <h1 className="text-2xl font-bold text-[#5D4D46]">特定商取引法に基づく表記</h1>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">販売事業者</h2>
            <p>株式会社ウィズダムネットワークス</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">運営責任者</h2>
            <p>伊藤 貴治</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">所在地</h2>
            <p>所在地については、請求があった場合、遅滞なく開示いたします。</p>
            <p>開示を希望される場合は、下記メールアドレスまでご連絡ください。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">電話番号</h2>
            <p>電話番号については、請求があった場合、遅滞なく開示いたします。</p>
            <p>開示を希望される場合は、下記メールアドレスまでご連絡ください。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">メールアドレス</h2>
            <p>
              <a href="mailto:wizmate@wisdomnetworks.co.jp" className="underline underline-offset-4">
                wizmate@wisdomnetworks.co.jp
              </a>
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">販売URL</h2>
            <p>
              <a href="https://wizmate.jp" className="underline underline-offset-4">
                https://wizmate.jp
              </a>
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">販売価格</h2>
            <p>各プランの料金は、以下のとおりです。表示価格は税込価格です。</p>
            <ul className="space-y-2 pl-5">
              <li>・フリープラン：無料</li>
              <li>・スタンダードプラン：月額3,300円（税込）</li>
              <li>・エグゼクティブプラン：月額11,000円（税込）</li>
            </ul>
            <p>特典コードが適用される場合、その有効期間、利用可能機能、利用回数、上限その他の条件は、コード適用画面、管理画面または当社が別途表示する条件に従います。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">商品代金以外に必要な料金</h2>
            <p>本サービスの利用に必要なインターネット接続料金、通信料金、端末費用その他の費用は、ユーザーの負担となります。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">支払方法</h2>
            <p>クレジットカード決済</p>
            <p>その他、当社が指定する決済方法</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">支払時期</h2>
            <p>有料プラン申込時に初回決済が行われます。</p>
            <p>以後、Stripe上のサブスクリプションの請求サイクルに従い、月ごとに自動決済されます。</p>
            <p>無料プランから有料プランへ変更した場合は、有料プラン申込時に決済が行われます。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">サービス提供時期</h2>
            <p>無料プランは、利用登録完了後、直ちに利用可能となります。</p>
            <p>有料プランは、決済完了後、直ちに利用可能となります。</p>
            <p>ただし、システム処理、外部サービス連携、通信環境等により、利用開始まで時間を要する場合があります。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">動作環境</h2>
            <p>本サービスは、以下の環境での利用を想定しています。</p>
            <ul className="space-y-2 pl-5">
              <li>・最新版のGoogle Chrome</li>
              <li>・最新版のSafari</li>
              <li>・iPhone Safari</li>
              <li>・LINEアプリ</li>
              <li>・LINEアプリ内ブラウザ</li>
              <li>・その他、当社が対応対象として案内する環境</li>
            </ul>
            <p>端末、OS、ブラウザ、通信環境、外部サービスの仕様により、一部機能が利用できない場合があります。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">申込みの有効期限</h2>
            <p>特別な定めがある場合を除き、申込みの有効期限はありません。</p>
            <p>キャンペーン、無料期間、特典コード、限定価格等を実施する場合は、対象期間および条件を申込画面、コード適用画面または管理画面に表示します。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">返品・キャンセル</h2>
            <p>本サービスはデジタルサービスの性質上、サービス提供開始後の返品またはキャンセルはできません。</p>
            <p>法令上必要な場合を除き、既に支払われた利用料金の返金は行いません。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">解約</h2>
            <p>ユーザーは、本サービス上の管理画面、Stripeが提供する管理画面、または当社所定の方法により、有料プランを解約できます。</p>
            <p>月額プランを解約した場合、次回更新日以降の請求は停止されます。</p>
            <p>解約手続き完了後も、既に支払済みの利用期間中は、当該プランを利用できます。</p>
            <p>日割り返金は行いません。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">利用上限</h2>
            <p>各プランの利用可能機能、利用回数、上限、対象機能、制限事項は、本サービス上の料金ページ、申込画面または管理画面に表示します。</p>
            <p>主な利用上限は以下のとおりです。</p>
            <PlanLimitTable />
            <p>※ {PLAN_UNLIMITED_NOTE}</p>
            <p className="font-semibold">定期配信頻度</p>
            <PlanFrequencyTable />
            <p>スタンダードプランのレポート定期配信は3枠ですが、毎日は対象外です。エグゼクティブプランでは日次レポートに対応します。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">不具合・契約不適合への対応</h2>
            <p>本サービスに不具合がある場合、ユーザーは当社所定の問い合わせ先に連絡するものとします。</p>
            <p>当社は、内容を確認のうえ、合理的な範囲で修正、代替対応、利用料金の返金その他当社が適切と判断する対応を行います。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">サービスに関する注意事項</h2>
            <p>本サービスは、AIによる情報整理、相談支援、ニュース/レポート配信、調査補助等を行うサービスです。</p>
            <p>AIが生成する回答、提案、要約、レポートその他の出力は、正確性、完全性、最新性、特定目的への適合性を保証するものではありません。</p>
            <p>法律、税務、会計、労務、医療、金融、投資、許認可その他専門的判断を要する事項については、必要に応じて専門家に確認してください。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">問い合わせ先</h2>
            <p>
              <a href="mailto:wizmate@wisdomnetworks.co.jp" className="underline underline-offset-4">
                wizmate@wisdomnetworks.co.jp
              </a>
            </p>
          </section>

          <p>最終更新日：2026年6月29日</p>
    </LegalPageShell>
  );
}
